<template>
  <div id="mailpage">
    <div>
      <!-- 头部返回按钮 -->
    <div class="head">
       <b-navbar toggleable="lg" type="light" variant="faded">
        <b-navbar-brand href="#" class="headText" @click="goBack">&lt;返回</b-navbar-brand>
      </b-navbar>
    </div>
      <div class="topDiv">
        <h6 class="h6Text">请填写您的邮寄地址</h6>
      </div>
      <b-container align="left">
        <div class="modDiv">
          <b-row class="rowItem">
            <b-col cols="4">
              <label for="input-name" class="mt-3">所在地区</label>
            </b-col>
            <b-col cols="8"> 
                <b-row>
                    <b-col cols="6" class="colIntr">
                      <!-- 请选择省市 -->
<b-form-select v-model="provinceText" :options="provinceS" size="sm" class="mt-3" @change="selectS"></b-form-select>
                    </b-col>
                    <b-col cols="6" class="colIntr">
                      <!-- 请选择区域 -->
                      <b-form-select v-model="cityText" :options="cityS" size="sm" class="mt-3" @change='selectQ'></b-form-select>
                      </b-col>
                    </b-row>
                 </b-col>
          </b-row>
        </div>

        <div>
          <b-form-textarea
            id="textarea-no-resize"
            placeholder="请填写详细地址,具体到门牌号"
            rows="2"
            v-model="mailAddress"
            no-resize
          ></b-form-textarea>
        </div>

        <div>
          <b-row>
            <b-col cols="1">
              <b-form-checkbox
                id="checkbox-1"
                v-model="status"
                name="checkbox-1"
                value="accepted"
                unchecked-value="not_accepted"
              />
            </b-col>
            <b-col>
              我已阅读《<font color="red" @click="showRules()"
                >中国银行借记卡章程</font
              >》并同意相关内容。我授权齐鲁银行将本人申请信息提供给齐鲁银行个性化定制卡业务合作方。
            </b-col>
          </b-row>
          <br>
          <b-row class="rowItemFee">
            <b-col cols="1"> </b-col>
            <b-col>
              下一步将由我行合作伙伴恒宝股份有限公司对图片进行处理及卡片费用结算。
            </b-col>
          </b-row>
        </div>

        <b-modal ref="rules" ok-only scrollable title="齐鲁银行黄山借记卡章程" ok-title="确定">
        <div>
          <p>
            第一条 为规范黄山借记卡的发行和使用，更好地为持卡人提供服务，根据《银行卡业务管理办法》及中国银行业监督管理委员会、中国人民银行的相关规定，特制定本章程。
          </p>
          <p>
            第二条
            黄山借记卡（以下简称黄山卡）是齐鲁银行发行的在中国境内及其他指定国家或地区使用的支付结算工具，具有消费结算、转账汇款、存取现金和投资理财等功能，可在齐鲁银行、特约单位和银联成员机构等联网终端上使用。黄山卡账户不得透支使用。
          </p>
          <p>
            第三条 黄山卡按介质类型分为磁条卡、纯芯片卡和磁条芯片复合卡（以下纯芯片卡和磁条芯片复合卡统称为芯片卡）。持卡人可在具备相应功能的设备上使用芯片卡进行交易。
          </p>

          <p>
            第四条 黄山卡的申领条件
            <p class="innerText">凡自愿遵守本章程且符合发卡条件的个人，均可凭本人有效身份证件向发卡银行申请黄山卡。申请黄山卡须填写申请表，确认遵守《齐鲁银行黄山借记卡章程》。</p>
            <p class="innerText">凡注册于中国境内的企业法人和机关、事业单位、社会团体法人，可凭中国人民银行核发的开户许可证和指定申领人的有效身份证件等资料向发卡机构申领单位卡。申领单位可为其指定的持卡人申领若干张单位卡。</p>
          </p>
          <p>
            第五条
            黄山卡个人卡持卡人可凭卡和密码在齐鲁银行营业网点、特约单位、网上银行、电话银行、手机银行、及具备存款、取款、转账、汇款、查询、缴费、投资理财等功能的自动柜员机以及其他具备相应功能的设备上使用。持卡人通过电子银行办理业务时，应遵守齐鲁银行电子银行业务的相关规定。
          </p>
          <p>
            第六条 单位卡不得存取现金，只能在齐鲁银行指定单位的财务POS终端上办理查询与转账业务。
          </p>

          <p>
            第七条 申请黄山卡必须设定密码。凡使用密码进行的交易，齐鲁银行均视为持卡人本人所为。依据密码等电子信息办理的各类交易所产生的电子信息记录均为该项交易的有效凭据。
          </p>

          <p>
            第八条 持卡人须妥善保管黄山卡和密码。因持卡人保管不当而造成的损失，齐鲁银行不承担责任。
            <p class="innerText">若持卡人连续三次输入交易密码不正确，发卡银行将对黄山卡实施账户锁定。若持卡人仍记得密码的，需持黄山卡和本人有效身份证件到发卡银行营业网点办理解除锁定手续，发卡银行验证密码无误后解除账户锁定。</p>
            <p class="innerText">若持卡人遗忘密码，持卡人应凭黄山卡和本人有效身份证件，向发卡银行营业网点书面申请办理密码重置手续。</p>
          </p>
          <p>
            第九条 持卡人可持具备电子现金功能的芯片卡办理电子现金业务。芯片卡电子现金业务是指发卡银行根据持卡人要求将现金或账户存款转至芯片内存储，交易时直接从芯片内扣款的业务。芯片卡电子现金视同现金管理，不计息，不挂失。
            <p class="innerText">芯片卡电子现金交易不设交易密码，凡使用电子现金进行的交易均视为持卡人本人所为。持卡人因芯片卡保管不善造成的损失，发卡银行不承担责任。</p>
          </p>
          <p>
            第十条 持卡人遗失黄山卡应及时办理卡片挂失手续，卡片挂失分为口头挂失和正式挂失。口头挂失5天内，须补办正式挂失手续，否则口头挂失将自动失效。黄山卡电子现金不可挂失。
            <p class="innerText">挂失手续办妥，挂失即生效，挂失生效前持卡人因遗失黄山卡和密码产生的一切经济损失，银行不承担责任。</p>
          </p>
          <p>
            第十一条
            持卡人可持黄山卡个人卡办理本外币的活期、定期存款业务。黄山卡个人卡内存款（黄山卡电子现金除外）按照中国人民银行规定的相应存款利率及计息办法计付利息。黄山卡单位卡账户内的资金按照中国人民银行及我行相关规定的计息办法及利率计付利息。
          </p>
          <p>
            第十二条
            持卡人凭卡在自动柜员机上办理业务时，因机器故障或操作失误造成自动柜员机吞卡的，可在吞卡后3个工作日内（从吞卡次日算起）凭本人有效身份证件及其他可以证明该黄山卡为持有人的材料到自动柜员机所属银行网点办理领卡手续。逾期未领的，自动柜员机所属银行网点有权按规定程序处理。
          </p>
          <p>
            第十三条 黄山卡卡片损坏，持卡人应持本人有效身份证件和黄山卡，到齐鲁银行营业网点办理换卡手续。因芯片卡芯片损坏换卡的，电子现金余额以30天后脱机交易流水到账的结果为准，补发新卡需30天。
          </p>
          <p>
            第十四条 持卡人须按齐鲁银行规定缴纳相关费用。若持卡人未按规定缴纳费用，齐鲁银行有权中止提供相应服务。黄山卡收费项目和收费标准见齐鲁银行各营业网点及网站公布的公告。
          </p>
          <p>第十五条
            黄山卡卡片所有权属于齐鲁银行，持卡人拥有卡片使用权，不得出租和转借。委托他人代为办理业务的，须符合我行相关业务的代办规定。发卡银行有权根据相关法律法规、本章程规定以及相关协议约定停止持卡人使用黄山卡，并授权有关银行和特约单位收回黄山卡。</p>
          <p>第十六条 持卡人终止使用黄山卡，应持黄山卡向齐鲁银行营业网点提出书面销卡申请，齐鲁银行营业网点受理后，即可办理销卡手续。</p>
          <p>第十七条 为保障持卡人账户资金安全，齐鲁银行在发现持卡人存在被他人冒用等使用风险时，有权暂时对该账户停止支付。</p>
          <p>第十八条
            齐鲁银行通过电子银行、自动柜员机或营业网点向持卡人提供账务查询等对账服务。持卡人对交易账务有疑义的，应在交易发生日起60日内提出查询申请。齐鲁银行应当在30日内给予答复，并按国家有关法律规定对持卡人的资信资料保密。</p>
          <p>第十九条 齐鲁银行依法对持卡人的信息承担保密义务，未经当事人同意不得向任何单位和个人披露，但法律、法规和规章另有规定，或者与持卡人另有约定的除外。</p>
          <p>第二十条
            因供电、通讯、系统故障等不可抗力导致黄山卡暂时无法使用的，齐鲁银行将视情况协助持卡人解决问题或者提供必要的帮助，但不承担相关责任以及因此可能给持卡人造成的损失。对于在交易过程中，因暂时的网络通讯故障或其他原因造成的错账现象，银行将根据实际交易情况进行账务处理，以保障持卡人及银行双方的利益均不受损失。</p>
          <p>第二十一条 本章程由齐鲁银行制订、解释，并保留根据国家法律和规定修改本章程的权利。本章程修改或黄山卡收费项目、标准及利率等发生调整，一经公布即为有效，无须另行通知。持卡人可以选择继续使用或者销卡。</p>
          <p>第二十二条 本章程未尽事宜，按照国家有关法律、法规、规章执行。</p>
        </div>
      </b-modal>

        <div align="center" class="actionArea">
          <b-button
            block
            variant="success"
            style="width: 80%"
            :disabled="disabled"
            @click="submitUserInfo()"
            >下一步</b-button
          >
        </div>

        <div v-show="showToast">
          <div class="weui-mask_transparent"></div>
          <div class="weui-toast">
            <p class="weui-toast__content">{{toastMsg}}</p>
          </div>
        </div>

        <b-modal v-model="showModal" centered >
          <template #modal-title>
            <b-row class="modTitle">
                <b-col cols="12">提示</b-col>
             </b-row>
             <b-row class="modText">
                <b-col cols="12">
                  借记卡申请信息如下，您是否申请借记卡？
                </b-col>
             </b-row>
          </template>
            <b-row class="rowItem">
                <b-col cols="6">申卡人：</b-col>
                <b-col cols="6">{{}}</b-col>
             </b-row>
             <div>
               <b-row class="rowItem">
                <b-col cols="6">身份证号码：</b-col>
                <b-col cols="6">{{}}</b-col>
                </b-row>
                <b-row class="rowItem">
                    <b-col cols="6">手机号：</b-col>
                    <b-col cols="6">{{}}</b-col>
                </b-row>
                <b-row class="rowItem">
                    <b-col cols="6">收货地址：</b-col>
                    <b-col cols="6">{{textSheng}}{{textShi}}{{mailAddress}}</b-col>
                </b-row>
             </div>
             <template #modal-footer>
               <b-container align="center">
                 <b-row class="rowItem">
                      <b-col cols="6" class="footerCol" @click="closeFooter">
                        取消
                      </b-col>
                      <b-col cols="6" class="footerCol" @click="sureFooter">
                        确定
                      </b-col>
                  </b-row>
                </b-container>
             </template>
        </b-modal>
      </b-container>
    </div>
  </div>
</template>

<script>
import axios from "axios";
// import init from "./city.js";
var config = require("../../common/config.js");
export default {
  name: "MailAddress",
  data() {
    return {
      disabled: true,
      status: "not_accepted",
      name: "",
      idNo: "",
      mobile: "",
      smsCode: "",
      textSheng: "", //汉字省
      textShi: "", //汉字市
      showModal: false, //确定提示弹框
      showToast: false, //吐司
      toastMsg: "", //吐司
      mailAddress: "", //具体地址
      provinceText: null, //省id
      cityText: null, //市id
      provinceS: [], //省
      cityS: [
        {
          text: "请先选择省份",
          value: null,
        },
      ], //市
    };
  },
  methods: {
    // 返回上一步
    goBack() {
      this.$router.go(-1);
    },
    //吐司
    showToastMsg: function (msg) {
      console.log("msg", msg);
      this.toastMsg = msg;
      let that = this;
      that.showToast = true;
      setTimeout(function () {
        that.showToast = false;
      }, 2000);
    },
    //关闭弹框
    closeFooter() {
      this.showModal = false;
    },
    //确定弹框
    sureFooter() {
      // //************ */
      // this.$router.push({
      //   name: "OrderPay_ql",
      //   params: {
      //     ...this.$route.params,
      //   },
      // });
      // return;
      // //************ */
      //
      axios
        .post(config.config_ql.submitUserInfo, {
          idNo: this.idNo,
          address: this.mailAddress,
        })
        .then(function (response) {
          // {code: 0, message: "交易成功", backSerialNumber: "2d506a29aaf846d3947ce1acfa9b38ad"}
          console.log(response);
          var data = response.data;
          if (0 === data.code) {
            that.toSelectCardface(data.backSerialNumber);
          } else {
            console.log("提交用户信息失败：" + data.message);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    showRules: function () {
      this.$refs["rules"].show();
    },
    toSelectCardface: function (bankSerialNumber) {
      this.$router.push({
        name: "OrderPay_ql",
        params: {
          bankSerialNumber: bankSerialNumber,
        },
      });
    },
    //下一步
    submitUserInfo: function () {
      let that = this;
      if (this.provinceText == null) {
        that.showToastMsg("请选择省份");
        return;
      }
      if (this.cityText == null) {
        that.showToastMsg("请选择市");
        return;
      }
      if (
        this.mailAddress == null ||
        this.mailAddress == undefined ||
        this.mailAddress == ""
      ) {
        that.showToastMsg("请输入具体地址");
        return;
      }
      let sheng, shi;
      this.provinceS.forEach((item, index) => {
        if (item.value == this.provinceText) {
          sheng = item.text;
          this.textSheng = item.text;
        }
      });
      this.cityS.forEach((item, index) => {
        if (item.value == this.cityText) {
          shi = item.text;
          this.textShi = item.text;
        }
      });

      this.showModal = true;
    },
    testAxios: function () {
      axios
        .get("http://localhost:8080")
        .then(function (res) {
          alert(res.data);
        })
        .catch(function (ex) {
          alert(ex);
        });
    },
    //选择省市
    selectS() {
      // console.log("value", this.provinceText);
    },
    //选择区域
    selectQ() {},
  },
  mounted: function () {
    // let proS = [
    //   {
    //     text: "请选择省份",
    //     value: null,
    //   },
    // ].concat(init.a1[0].provinces.province);
    // this.provinceS = proS; // init.a1[0].provinces.province
    // console.log("this.$route.params", this.$route.params);
    //   var param_identiy = this.$route.params.identiy;
    //   var identiy = JSON.parse(param_identiy)
    //   this.name = identiy.name;
    //   this.idNo = identiy.idNo;
    //   this.mobile = identiy.mobile;
    //   this.smsCode = identiy.smsCode;
    //   console.log("param_identiy:" + param_identiy)
  },
  watch: {
    status: function (newval, oldval) {
      // console.log("newval：" + newval, "oldval：" + oldval);
      if (newval == "accepted") {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },
    // 监听省下拉框
    provinceText: function (newval, oldval) {
      // console.log("newval", newval,oldval);
      if (newval == null) {
        this.cityText = null;
        this.cityS = [
          {
            text: "请先选择省份",
            value: null,
          },
        ];
        return;
      }
      this.cityText = null;
      this.provinceS.forEach((item, index) => {
        if (item.value == newval) {
          // console.log('item', item.cities.city)
          let newCitys = [
            {
              text: "请选择市",
              value: null,
            },
          ].concat(item.cities.city);
          this.cityS = newCitys; // item.cities.city;
          if (item.cities.city.length == 2) {
            //上海、北京、天津等特殊地区
            let newItemCity = [
              {
                text: "请选择市",
                value: null,
              },
            ]
              .concat(item.cities.city[0].areas.area)
              .concat(item.cities.city[1].areas.area);
            this.cityS = newItemCity;
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.head {
  border-bottom: 1px solid #ccc;
}
.head .headText {
  font-size: 15px;
}
#mailpage {
  width: 100%;
  height: 100%;
}
.actionArea {
  margin-top: 32px;
  margin-bottom: 24px;
}
.topDiv {
  height: 40px;
  width: 100%;
  background: #eee;
  color: red;
  /* margin-bottom: 5px; */
}
.topDiv .h6Text {
  line-height: 40px;
  padding-left: 15px;
  font-size: 14px;
}
.spanText {
  color: blue;
}
.modDiv {
  margin-bottom: 10px;
}
.colIntr {
  padding-left: 0;
  padding-right: 6px;
  color: red;
}
.modTitle {
  text-align: center;
}
.modText {
  text-align: center;
  font-size: 14px;
  /* color: #ccc; */
}
.footerCol {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/qilubank/mailaddress_ql.vue